<template>
  <div class="bb p30">
    <!--拒绝理由 -->
    <el-dialog width="420px" v-model="modifyTopicFormShow" title="拒绝理由">
      <el-form
        :model="modifyTopicForm"
        ref="modifyTopicForm"
        :rules="modifyTopicRules"
      >
        <el-form-item
          class="w222"
          size="large"
          label="理由"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            resize="none"
            type="textarea"
            v-model="modifyTopicForm.name"
            autocomplete="off"
            :rows="5"
            placeholder="请输入拒绝理由"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="modifyTopicFormShow = false">取消</el-button>
          <el-button type="primary" @click="submitForm('modifyTopicForm')"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <div v-loading="topicArrLoading">
      <div class="mb20">
        <el-table :data="topicArr" height="60vh" style="width: 100%">
          <!-- <el-table-column label="ID" width="80" prop="id"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="用户昵称"
            width="220"
            prop="user.nickname"
          >
          </el-table-column>
          <el-table-column label="用户手机号" width="160">
            <template #default="{ row, $index }">
              <div class="mobile-column">
                <!-- 显示/隐藏控制 -->
                <div class="mobile-display">
                  <span
                    class="mobile-text"
                    :title="setShowSj.has(row.id) ? row.user.mobile : ''"
                  >
                    {{
                      setShowSj.has(row.id)
                        ? row.user.mobile
                        : getDisplayMobile(row)
                    }}
                  </span>

                  <el-button
                    type="text"
                    size="small"
                    @click.stop="toggleMobileDisplay(row, $index)"
                    :class="{
                      'view-btn': !setShowSj.has(row.id),
                      'hide-btn': setShowSj.has(row.id),
                    }"
                  >
                    {{ setShowSj.has(row.id) ? "隐藏" : "查看" }}
                  </el-button>
                </div>

                <!-- 点击复制 -->
                <el-tooltip content="点击复制手机号" placement="top">
                  <span class="copy-icon" @click.stop="copyMobile(row.mobile)">
                    <i class="el-icon-document-copy"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="申请理由"
            prop="apply_reason"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="申请时间"
            width="200"
            prop="createtime_text"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="审核状态">
            <template #default="{ row, $index }">
              <template v-if="row.status === 1">待审核</template>
              <template v-if="row.status === 2">审核成功</template>
              <template v-if="row.status === 3">审核失败</template>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="拒绝理由"
            prop="refuse_reason"
          >
          </el-table-column>
          <el-table-column label="操作" width="300" align="center">
            <template #default="scope">
              <template v-if="scope.row.status === 1">
                <el-button
                  type="primary"
                  size="large"
                  @click="reviewYes(scope.$index, scope.row)"
                  >同意</el-button
                >
                <el-button
                  type="danger"
                  size="large"
                  @click="reviewNo(scope.$index, scope.row)"
                  >拒绝</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @current-change="handleCurrentChangeTopic"
          :current-page="pageTopic"
          :page-size="15"
          layout="total, prev, pager, next, jumper"
          :total="totalTopic"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import { addSiteStatistics } from "@/utils/common";
export default {
  data() {
    return {
      pageTopic: 1, // 话题页码
      totalTopic: 0, // 话题总数
      topicArr: [], // 话题列表数组
      topicArrLoading: false, // 话题列表加载状态
      modifyTopicFormShow: false, // 话题表单展示状态
      modifyTopicForm: {
        id: null,
        name: "",
        user: {},
      }, // 话题表单
      modifyTopicRules: {
        name: [{ required: true, message: "请输入拒绝理由", trigger: "blur" }],
      }, // 话题表单验证规则
      setShowSj: new Set(),
    };
  },
  methods: {
    // 格式化手机号（隐藏中间四位）
    formatMobile(mobile) {
      if (!mobile || typeof mobile !== "string") {
        return "";
      }

      // 处理各种格式的手机号
      const cleaned = mobile.replace(/\D/g, "");

      if (cleaned.length === 11) {
        // 标准11位手机号
        return `${cleaned.substring(0, 3)}****${cleaned.substring(7)}`;
      } else if (cleaned.length > 4) {
        // 其他长度的号码，隐藏中间部分
        const start = Math.floor(cleaned.length / 4);
        const end = Math.floor((cleaned.length * 3) / 4);
        const hidden = "*".repeat(end - start);
        return `${cleaned.substring(0, start)}${hidden}${cleaned.substring(
          end
        )}`;
      }

      return mobile;
    },
    // 获取显示的手机号
    getDisplayMobile(row) {
      return row.showFullMobile
        ? row.user.mobile
        : this.formatMobile(row.user.mobile);
    },
    // 切换手机号显示状态
    toggleMobileDisplay(row, index) {
      if (this.setShowSj.has(row.id)) {
        this.setShowSj.delete(row.id);
      } else {
        this.setShowSj.clear();
        this.setShowSj.add(row.id);
      }
    },
    // 获取我的话题列表
    async getTopicList(page) {
      this.topicArrLoading = true;
      const res = await request.post("/teacher/circle/getApplyCircle", {
        page,
        limit: 15,
      });
      var topicArr = res.data.data;
      for (const item of topicArr) {
        item.isTopDisabled = false;
      }
      this.topicArr = topicArr;
      this.totalTopic = res.data.total;
      this.pageTopic = page;
      this.topicArrLoading = false;
    },
    //审核同意
    reviewYes(index, row) {
      // this.modifyTopicForm.id = row.id;
      // this.modifyTopicForm.name = row.name;
      // this.modifyTopicFormShow = true;
      this.$confirm("确认审核同意吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleApplyCircle(2, row);
      });
      // console.log(index, row);
    },
    //审核拒绝
    reviewNo(index, row) {
      this.modifyTopicForm.id = row.id;
      this.modifyTopicForm.user.mobile = row.user.mobile;
      this.modifyTopicFormShow = true;
    },
    async handleApplyCircle(status, row, refuse_reason = "") {
      addSiteStatistics({
        type: 394,
        info: `${status == 2 ? "同意" : "拒绝"}，用户手机号：${
          row.user.mobile
        }`,
      });
      const res = await request.post("/teacher/circle/handleApplyCircle", {
        id: row.id,
        status,
        refuse_reason,
      });
      this.$message.success(res.msg);
      this.getTopicList(this.page);
      if (refuse_reason) {
        this.modifyTopicFormShow = false;
      }
    },
    handleCurrentChangeTopic(val) {
      this.getTopicList(val);
    },

    submitForm: Debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleApplyCircle(
            3,
            this.modifyTopicForm,
            this.modifyTopicForm.name
          );
        }
      });
    }),
  },
};
</script>

<style scoped>
.w222 /deep/ .el-form-item__content {
  width: 334px !important;
  flex: initial !important;
}
</style>
